import React, { useEffect, useState } from "react";
import { Box, Button, makeStyles, Typography } from "@material-ui/core";
import { Warning } from "@material-ui/icons";
import API from "../../middleware/Api";

const useStyles = makeStyles((theme) => ({
    warningBanner: {
        backgroundColor: "#fff3cd",
        borderBottom: "2px solid #ffc107",
        padding: theme.spacing(1, 3),
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: theme.spacing(1),
    },
    warningBannerDanger: {
        backgroundColor: "#f8d7da",
        borderBottom: "2px solid #dc3545",
    },
    warningIcon: {
        color: "#856404",
        marginRight: theme.spacing(1),
    },
    warningIconDanger: {
        color: "#721c24",
        marginRight: theme.spacing(1),
    },
    warningText: {
        color: "#856404",
        flex: 1,
    },
    warningTextDanger: {
        color: "#721c24",
        flex: 1,
    },
    renewButton: {
        marginLeft: theme.spacing(2),
        whiteSpace: "nowrap",
    },
}));

export default function ExpireWarning() {
    const classes = useStyles();
    const [membership, setMembership] = useState(null);

    useEffect(() => {
        API.get("/user/membership")
            .then((response) => {
                if (response.data && response.data.will_expire_soon) {
                    setMembership(response.data);
                }
            })
            .catch((e) => {
                // ignore
            });
    }, []);

    const handleDismiss = () => {
        if (membership) {
            const today = new Date().toDateString();
            localStorage.setItem("membership_warning_dismissed", today);
        }
        setMembership(null);
    };

    if (!membership) return null;

    // Check if already dismissed today
    const dismissed = localStorage.getItem("membership_warning_dismissed");
    if (dismissed === new Date().toDateString()) return null;

    const isExpired = membership.days_remaining <= 0;
    const isDanger = membership.days_remaining <= 3;

    return (
        <Box className={`${classes.warningBanner} ${isDanger ? classes.warningBannerDanger : ""}`}>
            <Box display="flex" alignItems="center" flex={1}>
                <Warning className={isDanger ? classes.warningIconDanger : classes.warningIcon} />
                <Typography variant="body2" className={isDanger ? classes.warningTextDanger : classes.warningText}>
                    {membership.warning}
                </Typography>
            </Box>
            <Box display="flex" alignItems="center">
                <Button
                    variant="contained"
                    size="small"
                    color="primary"
                    className={classes.renewButton}
                    href="/membership"
                >
                    立即续费
                </Button>
                <Button size="small" onClick={handleDismiss} style={{ marginLeft: 8 }}>
                    ✕
                </Button>
            </Box>
        </Box>
    );
}
